import { Maybe } from '../../..';

export const FullName = ({
  person,
}: {
  person: Maybe<{
    firstName?: Maybe<string>;
    middleName?: Maybe<string>;
    lastName?: Maybe<string>;
  }>;
}) => [person?.firstName, person?.lastName].filter(Boolean).join(' ');
